<template>
  <!-- 框架协议详情 -->
  <div class="m-t-15">
    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="框架协议信息" />

        <div class="section-content">
          <jczh-descriptions
            :info="formData"
            :option="detailInfo"
            :el-attrs="{
              size: 'medium',
              column: 3,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <base-section-title class="section-title" title="品目信息" />

        <!--筛选条件-->
        <div class="m-l-20 m-r-20">
          <el-form :model="filterForm" :inline="true" label-suffix="：">
            <el-form-item label="品目编码">
              <el-input
                v-model.trim="filterForm.itemCode"
                clearable
                placeholder="请输入品目编码"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getPurchaseFrameAgreementDetail">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <material-table
          ref="materialTable"
          :table-data="formData.itemList"
          :can-edit="false"
          :table-config-fun="() => materialConfig"
          :show-summary="false"
        />
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :remark-list="remarkList"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import MaterialTable from '@/components/common/MaterialComponent/index'
import RecordRemark from '@/components/common/RecordRemark'

// 数据字典
import {
  purchaseFrameAgreementStatusDict,
  purchaseFrameAgreementSourceTypeDict
} from '@/dictionary/supplier-management/frame-agreement'

// 工具函数
import { strToThousands } from '@/utils/utils'

// 后端api接口
import { getPurchaseFrameAgreementDetailApi } from '@/api/supplier-management/frame-agreement'

export default {
  name: 'PurchaseFrameAgreementInfo',

  components: {
    BaseSectionTitle,
    MaterialTable,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      // 数据字典
      purchaseFrameAgreementStatusDict,
      purchaseFrameAgreementSourceTypeDict,

      formData: {},
      detailInfo: [
        {
          label: '协议来源',
          prop: 'sourceType',
          filter: value =>
            purchaseFrameAgreementSourceTypeDict.translate(value).label
        },
        { label: '中标供应商', prop: 'supplierName' },
        { label: '合同编号', prop: 'agreementCode' },
        {
          label: '合同开始时间',
          prop: 'agreementStartTime',
          filter: value => (value ? `${value.split(' ')?.[0]}` : '-')
        },
        {
          label: '合同结束时间',
          prop: 'agreementEndTime',
          filter: value => (value ? `${value.split(' ')?.[0]}` : '-')
        },
        { label: '采购执行人', prop: 'executorName' },
        {
          label: '协议状态',
          prop: 'agreementStatus',
          filter: value =>
            purchaseFrameAgreementStatusDict.translate(value).label,
          hideFun: value => {
            const showAgreementStatusArr = [
              purchaseFrameAgreementStatusDict.UN_VALIDITY.value,
              purchaseFrameAgreementStatusDict.VALIDITY.value,
              purchaseFrameAgreementStatusDict.EXPIRED.value
            ]
            return !showAgreementStatusArr.includes(value?.agreementStatus)
          }
        }
      ],

      // 筛选
      filterForm: {
        itemCode: ''
      },

      // 品目表格配置
      materialConfig: [
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '品目单位', prop: 'unitType', minWidth: 100 },
        {
          label: '不含税单价(元)',
          prop: 'unitPrice',
          transProp: 'agreementPrice',
          filter: value => strToThousands(value),
          minWidth: 120
        },
        {
          label: '税率(%)',
          prop: 'taxRate',
          transProp: 'agreementTaxRate',
          minWidth: 100
        },
        { label: '交货时间(天)', prop: 'deliveryDay', minWidth: 120 },
        { label: '备注', prop: 'remarks', minWidth: 100 }
      ]
    }
  },

  watch: {
    'requestQuery.agreementId': {
      handler() {
        this.getPurchaseFrameAgreementDetail()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 获取详情
     */
    getPurchaseFrameAgreementDetail() {
      if (!this.requestQuery.agreementId) return

      getPurchaseFrameAgreementDetailApi({
        agreementId: this.requestQuery.agreementId,
        ...this.filterForm
      })
        .then(res => {
          this.formData = res?.data || {}
          this.$emit('getDetail', this.formData)
        })
        .catch(err => {
          this.$message.error(err?.message || '获取详情失败')
        })
    },

    handleReset() {
      this.filterForm.itemCode = ''
      this.getPurchaseFrameAgreementDetail()
    }
  }
}
</script>
